import { Container, Section } from 'components'
import { InnerHtml } from 'components/ui'
import { useIam, useMappedTranslation, usePageTitle } from 'hooks'
import { useExperiments } from 'hooks/use-experiment'
import { Button } from 'oneui'
import { generateRandomString } from 'utils/common'
import { COUNTRY_CODES, DOMAINS } from 'utils/constants'
import i18n from 'utils/i18n'

import { QUERY_PARAMETERS } from './constants'

const RegionError = () => {
  const t = useMappedTranslation()
  usePageTitle(t('iam.01.Common.Title.Account.country.or.region.not.supported'))

  const experiments = useExperiments()
  const { handleSignIn } = useIam()

  const isChinaMBR = window.location.hostname.endsWith(DOMAINS.CHINA)

  // Replace the endpoint to switch between China and Global endpoints for sign-in.
  const replaceEndpoint = (endpoint: string) => {
    const hostParts = endpoint.split('.')
    let domain = hostParts[hostParts.length - 1]
    // Replace the country code in the domain name. This avoids any unintended changes in the hostname
    domain = domain.replace(isChinaMBR ? DOMAINS.CHINA : DOMAINS.GLOBAL, isChinaMBR ? DOMAINS.GLOBAL : DOMAINS.CHINA)
    hostParts.splice(-1, 1)
    const newHost = hostParts.concat(domain).join('.')

    return newHost
  }

  const navigateToAlternateSignInUrl = async () => {
    const clientId = `${process.env.REACT_APP_CLIENT_ID}`
    const state = generateRandomString(10)
    const alternateHost = replaceEndpoint(window.location.host)
    const redirectUri = `${window.location.protocol}//${alternateHost}${process.env.REACT_APP_SIGN_IN_REDIRECT_PATH}`
    const iam3RedirectionFlag = await experiments.getIam3RedirectionFlag(!isChinaMBR ? COUNTRY_CODES.CHINA : i18n.countryCode)
    const alternateSignInUrl = replaceEndpoint(
      (iam3RedirectionFlag ? process.env.REACT_APP_SIGN_IN_URL : process.env.REACT_APP_LEGACY_SIGN_IN_URL)!
    )

    const parameters = [
      { key: QUERY_PARAMETERS.CLIENT_ID, value: clientId },
      { key: QUERY_PARAMETERS.REDIRECT_URI, value: redirectUri },
      { key: QUERY_PARAMETERS.RESPONSE_TYPE, value: 'code' },
      { key: QUERY_PARAMETERS.LOCALE, value: i18n.language.replace('-', '_') },
      { key: QUERY_PARAMETERS.STATE, value: state },
      { key: QUERY_PARAMETERS.COUNTRY_CODE, value: isChinaMBR ? COUNTRY_CODES.CHINA : i18n.countryCode }
    ]

    const params = new URLSearchParams()
    parameters.forEach(({ key, value }) => {
      params.append(key, value)
    })

    window.location.href = alternateSignInUrl + '?' + params
  }

  return (
    <Container size='small'>
      <Section
        sx={{ marginTop: { xs: '-72px', md: '12px' } }}
        title={t('iam.01.Common.Title.Account.country.or.region.not.supported')}
        description={
          <InnerHtml variant='body1' sx={{ fontWeight: '400' }}>
            {isChinaMBR
              ? t('iam.01.Common.Txt.This.site.only.supports.Samsung.account.created.in.China.Tap.Continue')
              : t('iam.01.Common.Txt.This.site.doesnt.support.Samsung.accounts.created.in.China.Tap.Continue')}
          </InnerHtml>
        }
        actions={[
          <Button key='continue' color='primary' onClick={navigateToAlternateSignInUrl} data-testid='Button6757E78A'>
            {t('iam.01.Common.Button.CONTINUE')}
          </Button>,
          <Button key='another-account' color='secondary' onClick={handleSignIn} data-testid='ButtonA6F04BAA'>
            {t('iam.04.SignIn.2-Step.Failed.Button.Sign.in.with.another.account')}
          </Button>
        ]}
        actionsSx={{
          mt: { md: '72px', xs: '20px' },
          '&:not(:first-of-type)': { mt: { md: '72px', xs: '20px' } },
          flexDirection: 'column',
          gap: '12px'
        }}
      ></Section>
    </Container>
  )
}

export default RegionError
